export const channels = {
  studentRoomChannel: (roomId: string) => `student-room-${roomId}`,
  teacherRoomChannel: (roomId: string) => `teacher-room-${roomId}`,
  attachFileClientChannel: (channelId: string) => `attach-file-client-${channelId}`,
  attachFileServerChannel: (channelId: string) => `attach-file-server-${channelId}`,
  reviewerGradingChannel: (reviewerId: string) => `reviewer-grading-${reviewerId}`,
  submissionGradingChannel: (submissionId: string) => `submission-grading-${submissionId}`,
  teacherQuizChannel: (assignmentId: string) => `teacher-quiz-${assignmentId}`,
};

export const events = {
  toolChat: 'toolChat',
  roomState: 'roomState',
  roomStudentState: 'roomStudentState',
  roomStudentJoined: 'roomStudentJoined',
  flaggedMessage: 'flaggedMessage',
  threadSummarized: 'threadSummarized',
  roomStudentSummarized: 'roomStudentSummarized',
  attachFile: 'attachFile',
  attachFileJoined: 'attachFileJoined',
  attachFileJoinedPing: 'attachFileJoinedPing',
  attachFileJoinedPong: 'attachFileJoinedPong',
  attachFileDone: 'attachFileDone',
  attachFileModalClosed: 'attachFileModalClosed',
  gradingStarted: 'gradingStarted',
  gradingProgress: 'gradingProgress',
  gradingCompleted: 'gradingCompleted',
  gradingError: 'gradingError',
  reviewerBatchStarted: 'reviewerBatchStarted',
  reviewerBatchCompleted: 'reviewerBatchCompleted',
  reviewerCompleted: 'reviewerCompleted',
  reviewerError: 'reviewerError',
  quizStudentJoined: 'quizStudentJoined',
  quizAnswersUpdated: 'quizAnswersUpdated',
  quizFinished: 'quizFinished',
  quizCompletionProcessed: 'quizCompletionProcessed',
} as const;
